/* eslint-disable indent */
import { Select } from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import styled from 'styled-components';

import { AgGridTablePageContainer } from '@/constants';
import { COLORS } from 'theme';

import { ROLE_BACKGROUND_COLOR } from './constants';

export const TabHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  row-gap: 16px;
  align-items: center;
`;

export const TrashIcon = styled(IconButton)`
  && {
    padding: 0;
  }
`;

export const Header = styled.div`
  place-self: start;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  margin: ${(props) => props.margin || '0'};
  color: ${({ theme, textColor }) => textColor || theme.app.black};
`;

export const Action = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 15px;
  justify-self: end;
  align-self: ${({ alignCenter }) => (alignCenter ? 'center' : 'unset')};
`;

export const Text = styled.div`
  font-weight: ${(props) => props.fontWeight || '400'};
  font-size: ${(props) => props.size || '1rem'};
  color: ${(props) => props.color || props.theme.app.black};
  grid-area: ${(props) => props.area || null};
  justify-self: ${(props) => props.justify || null};
  align-self: ${(props) => props.align || null};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${(props) => props.disableEllipsis && `white-space: normal;`};
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign}` : ``)};
`;

export const VersonRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  height: 60px;
  width: 100%;
  min-width: max-content;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  column-gap: 15px;
  align-items: center;
  padding: inherit;
`;
export const TabLayoutWrapper = styled(AgGridTablePageContainer)`
  height: 100%;
`;

export const AnnounceMentsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  height: 60px;
  width: 100%;
  min-width: max-content;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  column-gap: 15px;
  align-items: center;
  padding: 15px;
`;

export const StyledLink = styled(Link)`
  &&.MuiLink-root {
    justify-self: end;
    margin-right: 15px;
  }
`;

export const OutLinedButton = styled(Button)`
  &&.MuiButton-root {
    text-transform: none;
    color: ${(props) => props.theme.app.black};
    border: 1px solid ${(props) => props.theme.app.black};
    font-weight: 400;
    font-size: 14px;
    width: fit-content;
    justify-self: end;
  }
`;

export const UserManagementHeaderWrapper = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr auto auto auto;
  min-width: max-content;
  align-items: center;
  margin-bottom: 16px;
`;

export const UserTableLastLogin = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  width: fit-content;
  grid-gap: 10px;
`;

export const TextButton = styled(Button)`
  &&.MuiButton-root {
    color: ${COLORS.kinetikBlue};
    text-transform: none;
    width: fit-content;
    justify-self: end;

    &:disabled {
      cursor: not-allowed !important;
      pointer-events: unset !important;
      color: ${(props) => props.theme.text.disabled};
    }
  }
`;

export const StyledFormControl = styled(FormControl)`
  justify-content: center;
  align-items: center;
  width: fit-content;

  & .Mui-disabled {
    cursor: not-allowed !important;
  }
`;

export const StyledSelect = styled(Select)`
  font-size: 14px !important;
  font-weight: 400 !important;
  height: 30px !important;
  border-radius: 30px !important;
  color: #08193e !important;
  background: ${({ value }) => ROLE_BACKGROUND_COLOR[value] || '#F7F7F8'};

  & .MuiOutlinedInput-notchedOutline {
    border: 0;
  }
`;

export const NotifConfigRowItem = styled.div`
  display: grid;
  grid-template:
    'a b'
    'c b';
  justify-content: space-between;
  padding-bottom: 1.5rem;
  border-bottom: solid 1px #eaeaea;
  grid-gap: 8px;
  margin-bottom: 1.5rem;
`;

export const SwitchWrapper = styled.div`
  grid-area: ${(props) => (props.gridArea ? props.gridArea : '')};
  justify-self: end;
  align-self: center;
`;

export const RowItem = styled.div`
  display: flex;
  justify-content: space-between;
  grid-gap: 10px;
  padding: 1.5rem 0;
  ${(props) => !props.hideBorder && 'border-bottom: solid 1px #eaeaea'};
`;

export const BodyWrapper = styled.div`
  display: grid;
  grid-auto-flow: row;
  ${({ gap }) => (gap ? `gap: ${gap};` : ``)};
`;

export const Row = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 5px;
`;

export const ConfigurationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap: 18px;
`;

export const FieldDescriptionWrapper = styled.div`
  display: grid;
  gap: 0.5rem;
`;

export const FieldWrapper = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 0.5rem;
  padding: 10px 0;
`;
